<ng-container *transloco="let transloco; prefix: 'uiKit'">
  @if (formControl) {
    <div [class]="class() || 'mb-5'">
      <ng-select
        [appendTo]="'body'"
        [searchable]="false"
        [formControl]="formControl"
        [placeholder]="placeholder()"
        [clearable]="clearable()"
        [readonly]="disabled()"
        [notFoundText]="transloco('placeholders.noResults')"
        (close)="closeSelect.emit(); clearSearch()"
        (change)="onValueChange($event)"
      >
        @if (searchable()) {
          <ng-template ng-header-tmp>
            <div class="select-header d-flex align-items-center gap-2">
              <div
                class="search-input-wrapper position-relative d-flex align-items-center w-100"
              >
                <ui-keenicon
                  name="magnifier"
                  class="search-icon position-absolute text-muted"
                ></ui-keenicon>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [placeholder]="transloco('placeholders.search')"
                  [value]="searchTerm()"
                  (input)="onSearchInput($event)"
                  (keydown)="$event.stopPropagation()"
                />
              </div>
            </div>
          </ng-template>
        }
        @for (data of filteredItems(); track data) {
          <ng-option [value]="data.id" [disabled]="data.disabled ?? false">
            <span
              [innerHTML]="
                t()
                  ? t()!(data.name)
                  : isTransloco()
                    ? (data.name | transloco)
                    : data.name
              "
            ></span>
          </ng-option>
        }
        @if (allowManualEntry()) {
          <ng-template ng-notfound-tmp>
            <div class="manual-entry-notfound text-center p-4">
              <div class="text-muted mb-3">
                {{ manualEntryText() || transloco('placeholders.noResults') }}
              </div>
              @if (manualActionText()) {
                <ui-button
                  [size]="'sm'"
                  [severity]="'light-primary'"
                  [buttonText]="manualActionText()"
                  (click)="emitManualEntry()"
                ></ui-button>
              }
            </div>
          </ng-template>
        }
      </ng-select>
    </div>
    @if (control()!['touched']) {
      <ui-validation-form [control]="control()!"></ui-validation-form>
    }
  } @else {
    <div [class]="class() || 'mb-5'">
      <ng-select
        [appendTo]="'body'"
        [searchable]="false"
        [placeholder]="placeholder()"
        [clearable]="clearable()"
        [(ngModel)]="value"
        [disabled]="disabled()"
        [notFoundText]="transloco('placeholders.noResults')"
        (close)="closeSelect.emit(); clearSearch()"
        (change)="onValueChange($event)"
      >
        @if (searchable()) {
          <ng-template ng-header-tmp>
            <div class="select-header d-flex align-items-center gap-2">
              <div
                class="search-input-wrapper position-relative d-flex align-items-center w-100"
              >
                <ui-keenicon
                  name="magnifier"
                  class="search-icon position-absolute text-muted"
                ></ui-keenicon>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [placeholder]="transloco('placeholders.search')"
                  [value]="searchTerm()"
                  (input)="onSearchInput($event)"
                  (keydown)="$event.stopPropagation()"
                />
              </div>
            </div>
          </ng-template>
        }
        @for (data of filteredItems(); track data) {
          <ng-option [value]="data.id" [disabled]="data.disabled ?? false">
            <span
              [innerHTML]="
                t()
                  ? t()!(data.name)
                  : isTransloco()
                    ? (data.name | transloco)
                    : data.name
              "
            ></span>
          </ng-option>
        }
        @if (allowManualEntry()) {
          <ng-template ng-notfound-tmp>
            <div class="manual-entry-notfound text-center p-4">
              <div class="text-muted mb-3">
                {{ manualEntryText() || transloco('placeholders.noResults') }}
              </div>
              @if (manualActionText()) {
                <ui-button
                  [size]="'sm'"
                  [severity]="'light-primary'"
                  [buttonText]="manualActionText()"
                  (click)="emitManualEntry()"
                ></ui-button>
              }
            </div>
          </ng-template>
        }
      </ng-select>
    </div>
  }

  @if (description()) {
    <div class="form-text">{{ description() }}</div>
  }
  @if (lockedMessage()) {
    <div
      class="form-text d-inline-flex align-items-center gap-2 text-field-locked"
    >
      <i class="bi bi-lock-fill"></i>
      <span>{{ lockedMessage() }}</span>
    </div>
  }
</ng-container>
